import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  CreateDirectoryDto,
  FindDirectoriesAndFilesQueryDto,
  FindDirectoriesAndFilesResponse,
  FindDirectoryDetail,
  FindDirectoryFileDetail,
  findDirectoryQueryDto,
  findDirectoryResponse,
} from '@/@types/Directory';

const VuexModule = createModule({
  namespaced: 'theoryApiDirectoriesStore',
  strict: false,
});

export class DirectoriesStore extends VuexModule {
  private readonly directoriesRepository = RepositoryFactory.theoryApi.directoriesRepository();
  /** state */
  private directoriesAndFiles: FindDirectoriesAndFilesResponse | null = null;
  private currentDirectory: FindDirectoryDetail | null = null;
  private currentDirectoryAndFiles: FindDirectoriesAndFilesResponse | null = null;
  private parentDirectory: findDirectoryResponse | null = null;

  @mutation
  private setDirectoriesAndFiles(payload: FindDirectoriesAndFilesResponse | null) {
    this.directoriesAndFiles = payload;
  }

  @mutation
  private setCurrentDirectoryAndFiles(payload: FindDirectoriesAndFilesResponse | null) {
    this.currentDirectoryAndFiles = payload;
  }

  @mutation
  private setCurrentDirectory(payload: FindDirectoryDetail | null) {
    this.currentDirectory = payload;
  }

  @mutation
  private setParentDirectory(payload: findDirectoryResponse | null) {
    this.parentDirectory = payload;
  }

  /** ディレクトリ・ファイル一覧取得 */
  @action
  async fetchDirectoriesAndFiles(query: FindDirectoriesAndFilesQueryDto) {
    const directoriesAndFiles = await this.directoriesRepository.findDirectoriesAndFiles(query);
    this.setDirectoriesAndFiles(directoriesAndFiles);
  }

  @action
  async fetchCurrentDirectoryAndFiles(query: FindDirectoriesAndFilesQueryDto) {
    const currentDirectoryAndFiles = await this.directoriesRepository.findDirectoriesAndFiles(query);
    this.setCurrentDirectoryAndFiles(currentDirectoryAndFiles);
  }

  /** ディレクトリ詳細取得 */
  @action
  async fetchParentDirectory(params: { directoryId: number, query: findDirectoryQueryDto } | null) {
    if (params) {
      const directory = await this.directoriesRepository.findDirectory(params.directoryId, params.query);
      this.setParentDirectory(directory);
    } else {
      this.setParentDirectory(null);
    }
  }

  @action
  async fetchCurrentDirectory(directory: FindDirectoryDetail | null) {
    this.setCurrentDirectory(directory);
  }

  @action
  async deleteDirectoriesAndFiles() {
    this.setDirectoriesAndFiles(null);
  }

  @action
  async deleteParentDirectory() {
    this.setParentDirectory(null);
  }

  @action
  async deleteCurrentDirectory() {
    this.setCurrentDirectory(null);
  }

  @action
  async deleteDirectory(params: {
    directoryId: number,
    projectId: number,
  }) {
    await this.directoriesRepository.deleteDirectory(
      params.directoryId,
      params.projectId,
    );
  }

  /** ディレクトリ追加 */
  @action
  async createDirectory(params: CreateDirectoryDto) {
    await this.directoriesRepository.createDirectory(params);
  }

  get getDirectoriesAndFiles() {
    return this.directoriesAndFiles;
  }

  get getCurrentDirectory() {
    return this.currentDirectory;
  }

  get getCurrentDirectoryAndFiles() {
    return this.currentDirectoryAndFiles;
  }

  get getParentDirectory() {
    return this.parentDirectory;
  }
}
